export const EURO_SYMBOL = "€";

export const LANDSCAPE_PROJECTS_COUNT_THRESHOLD = 3;

export const NUMBER_OF_PROJECTS_IN_HIGHLIGHTS = 4;

export const MEDIA_QUERY_MAX_WIDTH = "768";
